import { useEffect } from 'react'
import { useIonViewWillEnter } from '@ionic/react'
import { giftCardMobx, mktConfigMobx } from '@mobxStore'
import repositoryMobx from '@mobx/mall/repository.mobx'

/** 商城仓库初始化 */
export const useMallRepositoryInit = (cps: boolean = false) => {
  // useIonViewWillEnter
  useIonViewWillEnter(() => {
    !cps && repositoryMobx.init()
  })

  // useEffect
  useEffect(() => {
    cps && repositoryMobx.init()
  }, [])
}

/** 礼品卡装修初始化 */
export const useGiftCardDecorationInit = (cps: boolean = false) => {
  // useIonViewWillEnter
  useIonViewWillEnter(() => {
    !cps && giftCardMobx.getEGiftCardDecoration()
  })

  // useEffect
  useEffect(() => {
    cps && giftCardMobx.getEGiftCardDecoration()
  }, [])
}

/** mktConfig */
export const useMktConfigInit = (cps: boolean = false) => {
  // useIonViewWillEnter
  useIonViewWillEnter(() => {
    !cps && mktConfigMobx.init()
  })

  // useEffect
  useEffect(() => {
    cps && mktConfigMobx.init()
  }, [])
}
